export default {
  "timeTravel.uatTimeTravel": "{uat} Time Travel",
  "timeTravel.uatTimeTravelTooltip":
    "You are viewing the participant experience using a future date and time.",
  "timeTravel.virtualDate": "Virtual Date",
  "todos.completedToday": "Completed today at {time}",
  "todos.completedYesterday": "Completed yesterday at {time}",
  "todos.completedAt": "Completed {date} at {time}",
  "todos.addedYesterday": "Added yesterday at {time}",
  "todos.addedToday": "Added today at {time}",
  "todos.addedOnDate": "Added {date}",
  "todos.newVersion": "New Version",
  "todos.completedVersion": "Version",
  "todos.ariaLabelBlocked": "{heading} {date} blocked",
  "todos.available": "Available",
  "todos.availableToday": "Available today at {date}",
  "todos.availableTomorrow": "Available tomorrow at {date}",
  "todos.surveyDueToday": "Due today by {date}",
  "todos.surveyDueTomorrow": "Due tomorrow by {date}",
  "todos.surveyDue": "Due by {date}",
  "todos.visitsDateAndTime": "{startTime} - {endTime}",
  "todos.availableTime": "Available at {time}",
  "todos.availableUntil": "Available until {date}",
  "todos.availableUntilToday": "Available until {time}",
  "todos.availableUntilTomorrow": "Available until tomorrow at {time}",
  "todos.resume": "Resume",
  "todos.updatedToday": "Updated today at {time}",
  "todos.updatedYesterday": "Updated yesterday at {time}",
  "todos.updatedAt": "Updated {date} at {time}",
  "todos.today": "Today",
  "todos.tomorrow": "Tomorrow",
  "todos.yesterday": "Yesterday",
  "todos.upcomingVisits": "Upcoming Visits",
  "todos.trainingAvailable": "Training Available",
  "todos.trainingAvailableDescription":
    "{trainingSurveyLabel} is now available.",
  "todos.completeNow": "Complete Now",
  "todos.back": "Back",
  "todos.navigateBack": "navigate back",
  "todos.diaryToDoCount": "{count} To Do",
  "completedTodos.completed": "Completed",
  "completedTodos.today": "Today",
  "completedTodos.noCompletedItems": "No completed items.",
  "completedTodos.studyTabMessage":
    "Looking for older consent forms or training surveys? Go to the Study tab.",
  "completedTodos.previousDiaries": "Previous Diaries",
  "diary.availableOnDate": "Available on {date}",
  "diary.toDo": "To Do",
  "diary.completed": "Completed",
  "diary.readMore": "Read More",
  "diary.readLess": "Read Less",
  "diary.requiredWarningTitle": "Add New",
  "diary.requiredWarningMessage":
    "You have one or more required surveys available. Are you sure you want to start a new one?",
  "diary.cancel": "Cancel",
  "diary.continue": "Continue",
  "diary.addNewDiary": "Add New",
  "diary.noItems": "No items to do.",
  "visits.back": "Back",
  "visits.backToVisits": "Back to visits",
  "visits.dateAndTime": "{date} · {time}",
  "visits.fallbackTitle": "(No title)",
  "visits.joinMeeting": "Join Meeting",
  "visits.otherHeader": "Visit",
  "visits.virtualHeader": "Virtual Visit",
  "visits.endTimePassed": "This visit's end time has passed.",
}
